import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Popover, Step, StepLabel, Stepper, Typography } from '@material-ui/core'
import _ from 'lodash'
import { getLabel, getStepDescription, steps, stepsMapper, stepsText } from './constant'
import { useStyles } from './style'
import StepConnector from '@material-ui/core/StepConnector'
import CancelIcon from '@material-ui/icons/Cancel'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { makeStyles, withStyles, styled } from '@material-ui/core/styles'

const CustomConnector = withStyles(theme => ({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 12px)',
    right: 'calc(50% + 12px)',
  },
  active: {
    '& $line': {
      borderColor: theme.palette.primary.main,
      opacity: '100%'
    },
  },
  completed: {
    '& $line': {
      borderColor: theme.palette.primary.main,
      opacity: '100%'
    },
  },
  line: {
    borderColor: '#707070',
    borderTopWidth: 3,
    borderRadius: 1,
    opacity: 0.17,
    width: '100%'
  },
}))(StepConnector)

const CustomStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  width: '100%',
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#784af4',
  }),
  '& .CustomStepIcon-errorIcon': {
    color: '#F32020',
    zIndex: 1,
    fontSize: 30,
  },
  '& .CustomStepIcon-completedIcon': {
    color: theme.palette.primary.main,
    zIndex: 1,
    fontSize: 30,
  },
  '& .CustomStepIcon-errorIcon:hover': {
    fontSize: 35,
  },
  '& .CustomStepIcon-completedIcon:hover': {
    fontSize: 35,
  },
  '& .CustomStepIcon-activeIcon': {
    color: '#707070',
    opacity: 0.5,
  },
  '& .CustomStepIcon-circle': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 22,
    height: 22,
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
    border: '2px solid #F47321',
    color: '#F47321',
    zIndex: 99,
    textAlign: 'center'
  },
  '& .CustomStepIcon-activeWrapper': {
    minHeight: '75px'
  },
}))

const CustomStepIcon = (props) => {
  const { active, completed, className, icon, error } = props
  return (
    <CustomStepIconRoot ownerState={{ active }} className={className}>
      {error ? (
        <Box display="flex" flexDirection="column" alignItems="center" className="CustomStepIcon-activeWrapper">
          <KeyboardArrowDownIcon className="CustomStepIcon-activeIcon" />
          <div className="CustomStepIcon-circle">
            <CancelIcon className="CustomStepIcon-errorIcon" />
          </div>
        </Box>
      ) : completed ? (
        <div className="CustomStepIcon-circle">
          <CheckCircleIcon className="CustomStepIcon-completedIcon" />
        </div>
      ) : active ? (
        <>
          <Box display="flex" flexDirection="column" alignItems="center" className="CustomStepIcon-activeWrapper">
            <KeyboardArrowDownIcon className="CustomStepIcon-activeIcon" />
            <div className="CustomStepIcon-circle">{icon}</div>
          </Box>
        </>
      ) : (
        <div className="CustomStepIcon-circle">{icon}</div>
      )}
    </CustomStepIconRoot>
  )
}

CustomStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
}

const CustomStepper = (props) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const [currentStep, setCurrentStep] = useState(0)

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  return (
    <>
      <Stepper alternativeLabel activeStep={_.get(props, 'currentStep', 0)} connector={<CustomConnector />} style={{ flexWrap: 'wrap', overflow: 'hidden' }}>
        {stepsText.map((label, index) => {
          const labelProps = {}
          if (label === stepsMapper[props.status]) {
            labelProps.error = true
          }
          return (
            <Step key={label}>
              <StepLabel {...labelProps} className={classes.customStepLabels} StepIconComponent={CustomStepIcon} onMouseEnter={(e) => { setCurrentStep(stepsText.indexOf(label)); handlePopoverOpen(e) }} onMouseLeave={handlePopoverClose} StepIconProps={{ setCurrentStep: setCurrentStep, handlePopoverOpen: handlePopoverOpen, handlePopoverClose: handlePopoverClose }}>
                <Box component="span" style={{ opacity: 0.5, color: '#000000', maxWidth: 150 }}>{getLabel(label, props.status)}</Box>
              </StepLabel>
            </Step>
          )
        })}
      </Stepper>
      <Popover
        classes={{ paper: classes.paper }}
        id="mouse-over-popover"
        style={{
          pointerEvents: 'none',
          marginTop: '10px'
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box className={classes.popoverContainer}>
          <Box display="flex" justifyContent="center">
            <img src={steps[currentStep].img} className={classes.popoverImg} alt="" />
          </Box>
          <Typography className={classes.popoverText}>{getStepDescription(currentStep, props.status)}</Typography>
        </Box>
      </Popover>
    </>
  )
}

export default CustomStepper
